<template>
  <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" title="绑定手机号" :showClose="false"
    :visible.sync="visible" width="43%" center>
    <el-form :model="formData" status-icon :rules="rules" ref="form" class="demo-ruleForm" size="medium"
      label-width="100px">
      <div>
        <p style="font-size:14px;color:orange;font-weight:bold;width:800px">
          注：根据国家相关法律法规的要求，请绑定您的手机号。 此外，绑定后您也将得到更好的使用体验，可以及时收到平台消息。</p>
      </div>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="formData.phone" @blur="handleBlur" auto-complete="off" placeholder="请输入手机号"
          style="width:50%;">
        </el-input>
        <el-tag type="success">{{checkphonemessage}}</el-tag>
      </el-form-item>
      <el-form-item label="验证码" prop="smscode" class="code">
        <el-input style="width:50%" v-model="formData.smscode" placeholder="验证码"></el-input>
        <el-button class="fsyzm" type="primary" :disabled="isDisabled" @click="sendCode">
          {{ buttonText }}</el-button>
      </el-form-item>
      <template v-if="isshow">
        <el-form-item label="用户身份" :rules="[
      { required: true, message: '请选择', trigger: 'blur' } 
    ]">

          <el-radio v-model="formData.Useridentity" label="1">个人</el-radio>
          <el-radio v-model="formData.Useridentity" label="2">单位职工<span style="color:red;">（注册后，单位负责人需进行审核后，才能获取相关权限）</span></el-radio>
        </el-form-item>
        <el-form-item label="工作单位" prop="ComId" v-if="formData.Useridentity=='2'">
          <el-autocomplete v-model="ComName" :trigger-on-focus="false" :style="{width: '100%'}"
            :fetch-suggestions="querySearchAsync" placeholder="请输入单位名称" @select="handleSelect"></el-autocomplete>
        </el-form-item>
        <el-form-item label="单位部门" v-if="formData.Useridentity=='2'">
          <el-select v-model="formData.Depet" placeholder="请选择单位部门">
            <el-option v-for="item in EnterpriseDept" :key="item.ID" :label="item.Name" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置密码" prop="LoginPass">
          <el-input v-model="formData.LoginPass" type="password" auto-complete="off" placeholder="请输入密码"
            style="width:50%;" show-password>
          </el-input>
          <el-tag type="success" name="密码必须包含数字字母，长度8-16位">密码必须包含数字字母，长度8-16位</el-tag>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input v-model="formData.checkPass" type="password" auto-complete="off" placeholder="请确认密码"
            style="width:50%;" show-password>
          </el-input>
        </el-form-item>
      </template>
      <el-form-item>
        <el-button class="btn btn-blue f-r3" type="primary" @click="submitForm()" style="width:50%;">确认
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import {
    SendMessage,
    BindAuthPhone,
    CheckPhone,
    GetEnterpriseNameByName,
    GetEnterpriseDeptNameByID,
    CheckUserRegistration
  } from "@/api/Register.js";
  import {
    validPassword
  } from "@/utils/validate";
  import store from '@/store';
  import userStorage from '@/utils/storage/userStorage'
  export default {
    name: "Bindingphonenumber",
    props: {
      Visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      let checkTel = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入手机号码"));
        } else if (!this.checkMobile(value)) {
          callback(new Error("手机号码不合法"));
        } else {
          CheckUserRegistration({
            phone: value
          }).then((res) => {
            if (res.Code === 200) {
              this.isDisabled = false;
              callback();
            } else {
              this.isDisabled = true;
              callback(new Error(res.Message));
            }
          });
        }
      };
      // <!--验证密码-->
      let validatePass = (rule, value, callback) => {
        if (value && !validPassword(value)) {
          callback(new Error("密码必须包含数字字母，长度8-16位"));
        } else {
          callback();
        }
      };
      // <!--二次验证密码-->
      let validatePassSecondaryPerson = (rule, value, callback) => {
        if (value && !validPassword(value)) {
          callback(new Error("密码必须包含数字字母，长度8-16位"));
        } else if (value !== this.formData.LoginPass) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      return {
        IsShowEnterprise: true,
        EnterpriseDept: [],
        checkphonemessage: "",
        isshow: true, //如果系统已有此手机号用户，则不用填写相关信息，只需要验证手机号，与微信进行绑定。
        isDisabled: false, // 是否禁止点击发送验证码按钮
        sendCodedate: "",
        flag: true,
        buttonText: "发送验证码",
        pwdType: "password",
        eyeType: "eye",
        ComName: "",
        rules: {
          phone: [{
            validator: checkTel,
            trigger: "blur",
            required: true
          }],
          ComName: [{
            trigger: "blur",
            message: "请输入企业名称",
            required: true
          }],
          Depet: [{
            trigger: "blur",
            message: "请输入企业部门",
            required: true
          }],
          LoginPass: [{
              validator: validatePass,
              trigger: "change",
              required: true
            },
            {
              min: 6,
              max: 18,
              message: "密码须为6-18个字符",
              trigger: "blur"
            },
          ],
          checkPass: [{
              validator: validatePassSecondaryPerson,
              trigger: "change",
              required: true
            },
            {
              min: 6,
              max: 18,
              message: "密码须为6-18个字符",
              trigger: "blur"
            },
          ],
        },
        formData: {
          phone: "",
          smscode: "",
          LoginPass: "",
          checkPass: "",
          ComId: "",
          Depet: "",
          Useridentity: "", //用户身份
        },
        visible: true,
      };
    },
    mounted() {

    },
    methods: {
      handleBlur() {
        CheckPhone({
          phone: this.formData.phone
        }).then((res) => {
          if (res.Code == 200) {
            if (res.Data != "") {
              this.checkphonemessage = res.Data;
              this.isshow = false;
            }
            else{
              this.isshow = true;
            }
          }
        });
      },
      handleSelect(item) {
        GetEnterpriseDeptNameByID({
          'ComId': item.ID
        }).then((res) => {
          if (res.Code == 200) {
            this.formData.ComId = item.ID;
            this.EnterpriseDept = res.Data;
          }
        });
      },
      querySearchAsync(queryString, cb) {
        GetEnterpriseNameByName({
          'EnterpriseName': queryString
        }).then((res) => {
          if (res.Code == 200) {
            let enterpriseResults = [];
            if (res.Data.length > 0) {
              enterpriseResults = res.Data;
            } else {
              enterpriseResults = [{
                value: "没有查询到您所在单位，请联系单位相关负责人进行单位入驻！",
                ID: "0"
              }];
            }
            //cb是回调函数，返回筛选出的结果数据到输入框下面的输入列表
            cb(enterpriseResults);
          } else {
            cb({
              value: "不好意思，服务器链接失败，请稍后再试",
              ID: "0"
            });
          }
        });
      },
      submitForm() {
        if (this.formData.Useridentity == "") {
          this.$warningMessage("请选择用户身份！");
          return false;
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.sendCodedate == "") {
              this.$warningMessage("请发送验证码");
              return false;
            }
            if (this.formData.smscode != "") {
              let UnionId = userStorage.getUnionId();
              if (UnionId) {
                if (this.sendCodedate + 4 * 60 * 1000 >= Date.now()) {
                  BindAuthPhone({
                    UnionId: UnionId,
                    phone: this.formData.phone,
                    smscode: this.formData.smscode,
                    LoginPass: this.formData.LoginPass,
                    ComId: this.formData.ComId,
                    Depet: this.formData.Depet
                  }).then((res) => {
                    if (res.Code === 200) {
                      this.$notify({
                        title: '成功',
                        message: '恭喜您，操作成功',
                        type: 'success'
                      });
                      this.$store.commit("user/mSetVerifyphonenumber", 'false');
                      this.$store.commit("user/msetUnionId", '');
                      this.visible = false;
                      this.$store
                        .dispatch("user/aAuthlogin", UnionId)
                        .then((res) => {
                          if (res.Code == 200 || res.Code == 10002) {
                            this.$router.push({
                              path: this.redirect || "/",
                            });
                          }
                        });
                    } else {}
                  });
                } else {
                  this.$warningMessage("验证码已经过期，请重新发送！");
                }
              } else {
                this.$warningMessage("参数错误，请刷新页面重新尝试下");
              }
            } else {
              this.$warningMessage("请输入验证码");
            }
          }
        });

      },
      // 验证手机号
      checkMobile(str) {
        let re = /^1\d{10}$/;
        if (re.test(str)) {
          return true;
        } else {
          return false;
        }
      },
      // <!--发送验证码-->
      sendCode() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            SendMessage({
              PhoneNumber: this.formData.phone
            }).then((res) => {
              if (res.Code == 200) {
                this.sendCodedate = Date.now();
                let time = 60;
                this.buttonText = "已发送";
                this.isDisabled = true;
                if (this.flag) {
                  this.flag = false;
                  let timer = setInterval(() => {
                    if (time > 0 && time <= 60) {
                      time--;
                      this.buttonText = time + " 秒";
                    } else {
                      clearInterval(timer);
                      this.buttonText = "重新获取";
                      this.isDisabled = false;
                      this.flag = true;
                    }
                  }, 1000);
                }
              }
            })
          }
        });
      },
      changeType() {
        this.pwdType = this.pwdType === 'password' ? 'text' : 'password';
        this.eyeType = this.eyeType === 'eye' ? 'eye-open' : 'eye';
      },
    },
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/User/Bindingphonenumber.vue